<template>
    <v-layout>
        <v-flex xs12 v-if="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex :class="showConnectors ? 'xs6' : '12'" v-if="!loading">
            <v-layout>
                <v-flex md4>
                    <v-card>
                        <v-card-title class="primary title">
                            <v-layout row>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }" >
                                        <v-icon small v-on="on" :color="debugMode ? 'success' : null" class="mr-3 cursor-as-pointer" v-if="canSwitchToDebug" @click="debugMode=!debugMode">fa-bug</v-icon>
                                    </template>
                                    <span>{{'Toggle Debug Mode'|translate}}</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }" >
                                        <v-icon small v-on="on" class="mr-3 cursor-as-pointer" v-if="canSwitchToDebug" @click="runMIS">fa-list</v-icon>
                                    </template>
                                    <span>{{'Run Integrity Scan'|translate}}</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }" >
                                        <v-icon small v-on="on" :color="showConnectors ? 'success' : null" class="mr-3 cursor-as-pointer" v-if="$can('update', 'Equipment')" @click="showConnectors=!showConnectors">fa-network-wired</v-icon>
                                    </template>
                                    <span>{{'Toggle Connectors'|translate}}</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }" >
                                        <v-icon small v-on="on" class="mr-3 cursor-as-pointer" v-if="$can('update', 'Equipment')" @click="equipDialog=true">fa-plus</v-icon>
                                    </template>
                                    <span>{{'Add Equipment'|translate}}</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }" >
                                        <v-icon small v-on="on" class="mr-3 cursor-as-pointer" v-if="$can('update', 'Points')" @click="mcpDialog=true">fa-plus-square</v-icon>
                                    </template>
                                    <span>{{'Add Multiple Calculated Points'|translate}}</span>
                                </v-tooltip>
                                <v-tooltip bottom v-if="writableConnector">
                                    <template v-slot:activator="{ on }" >
                                        <v-icon small v-on="on" class="mr-3 cursor-as-pointer" v-if="$can('update', 'Points')" @click="mwpDialog=true">fa-plus-square</v-icon>
                                    </template>
                                    <span>{{'Add Multiple Writable Points'|translate}}</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }" >
                                        <v-icon small v-on="on" class="mr-3 cursor-as-pointer" v-if="$can('update', 'Points')" @click="recalcDiag=true">fa-calculator</v-icon>
                                    </template>
                                    <span>{{'Recalculate Multiple Calculated Points'|translate}}</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }" >
                                        <v-icon small v-on="on" class="mr-3 cursor-as-pointer" v-if="$can('update', 'Points')" @click="autoBuildRelationships">fa-sitemap</v-icon>
                                    </template>
                                    <span>{{'Auto-create Equipment Relationships'|translate}}</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }" >
                                        <v-icon small v-on="on" class="mr-3 cursor-as-pointer" v-if="$can('update', 'Points')" @click="uploadDialog=true">fa-file-upload</v-icon>
                                    </template>
                                    <span>{{'Upload Point List'|translate}}</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }" >
                                        <v-icon small v-on="on" class="mr-3 cursor-as-pointer" v-if="$can('update', 'Points')" @click="exportPoints">fa-file-download</v-icon>
                                    </template>
                                    <span>{{'Download Point List'|translate}}</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }" >
                                        <v-icon small v-on="on" class="mr-3 cursor-as-pointer" v-if="$can('update', 'Points')" @click="multiUploadDialog=true">fa-upload</v-icon>
                                    </template>
                                    <span>{{'Upload Data'|translate}}</span>
                                </v-tooltip>
                                <maintenance-upload-dialog
                                    v-model="uploadDialog"
                                    v-if="uploadDialog"
                                    endpoint="/point-list-upload/"
                                    diff-options
                                    v-on:doreload="reloadTree(); uploadDialog=false"
                                    :title="'Point List upload'|translate"
                                    :upload-title="'Upload Point List CSV'|translate"
                                >
                                </maintenance-upload-dialog>
                                <maintenance-upload-dialog
                                    v-model="multiUploadDialog"
                                    v-if="multiUploadDialog"
                                    endpoint="/multiple-series-upload/"
                                    cleanup
                                    title="Data Upload"
                                    v-on:doreload="multiUploadDialog=false"
                                    upload-title="Upload CSV/Excel Data"
                                >
                                </maintenance-upload-dialog>
                                <equipment-record-dialog v-model="equipDialog" :item="{}" v-on:reloadequipments="reloadTree();equipDialog=false"></equipment-record-dialog>
                                <v-dialog v-model="mcpDialog" :max-width="800">
                                    <v-card v-if="mcpDialog">
                                        <v-card-title class="primary white--text title">
                                            {{'Add Multiple Calculated Points'|translate}}
                                        </v-card-title>
                                        <v-card-text>
                                            <v-autocomplete clearable v-model="mcpTypeFilter" :label="'Equipment Type filter'|translate" :items="equipTypeFilterOptions"></v-autocomplete>
                                            <v-autocomplete clearable v-model="mcpFloorFilter" :label="'Equipment Floor filter'|translate" :items="equipFloorFilterOptions"></v-autocomplete>
                                            <v-text-field v-model="mcpName" type="text" :label="'Sensor Name'|translate"></v-text-field>
                                            <v-text-field v-model="mcpForumla" clearable type="text" :label="'Sensor Formula'|translate" :hint="'ID replacement supported. Equipment that lack sensors are skipped.'|translate"></v-text-field>
                                            <v-switch color="success"
                                                      v-model="mcpEditExisting"
                                                      :label="'Edit Existing Points'|translate"
                                            ></v-switch>
                                            <div v-if="mcpTypeFilter||mcpFloorFilter">
                                                <v-alert v-if="matchingMCPTargets.length>0"
                                                         :value="true"
                                                         style="padding: 6px;"
                                                         type="success"
                                                >
                                                    {{'Matching Equipment : '|translate}}
                                                    <v-chip v-for="item in matchingMCPTargets">{{item}}</v-chip>
                                                </v-alert>
                                            </div>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn class="primary" @click="runMCP" :disabled="!$can('update', 'Points')||(!mcpTypeFilter&&!mcpFloorFilter)||!mcpName">{{'Create for all matching equipment'|translate}}</v-btn>
                                            <v-btn @click="mcpDialog=false">{{'Cancel'|translate}}</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-dialog v-model="mwpDialog" :max-width="800">
                                    <v-card v-if="mwpDialog">
                                        <v-card-title class="primary white--text title">
                                            {{'Add Multiple Writable Points'|translate}}
                                        </v-card-title>
                                        <v-card-text>
                                            <v-autocomplete clearable v-model="mwpTypeFilter" :label="'Equipment Type filter'|translate" :items="equipTypeFilterOptions"></v-autocomplete>
                                            <v-autocomplete clearable v-model="mwpFloorFilter" :label="'Equipment Floor filter'|translate" :items="equipFloorFilterOptions"></v-autocomplete>
                                            <v-text-field v-model="mwpName" type="text" :label="'Sensor Name'|translate"></v-text-field>
                                            <v-switch color="success"
                                                      v-model="mwpEditExisting"
                                                      :label="'Edit Existing Points'|translate"
                                            ></v-switch>
                                            <div v-if="mwpTypeFilter||mwpFloorFilter">
                                                <v-alert v-if="matchingMWPTargets.length>0"
                                                         :value="true"
                                                         style="padding: 6px;"
                                                         type="success"
                                                >
                                                    {{'Matching Equipment : '|translate}}
                                                    <v-chip v-for="item in matchingMWPTargets">{{item}}</v-chip>
                                                </v-alert>
                                            </div>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn class="primary" @click="runMWP" :disabled="!$can('update', 'Points')||(!mwpTypeFilter&&!mwpFloorFilter)||!mwpName">{{'Create for all matching equipment'|translate}}</v-btn>
                                            <v-btn @click="mwpDialog=false">{{'Cancel'|translate}}</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-dialog v-model="misWorkflowDialog" fullscreen persistent>
                                    <v-card v-if="misWorkflowDialog">
                                        <v-card-title class="primary white--text title">
                                            {{'Mapping Integrity Missing Points'|translate}}
                                        </v-card-title>
                                        <v-card-text>
                                            <v-layout row>
                                                <span class="ml-3" style="width:200px;">
                                                    <value-box
                                                        :value="completionPercentage"
                                                        unit="%"
                                                        icon=""
                                                        use-int
                                                        :title="'Mapping Completion'|translate">
                        </value-box>
                                                </span>

                                                <v-spacer></v-spacer>
                                                <span style="width:150px;">
                                                <v-switch color="success"  :label="'Pending Only'|translate" v-model="misPendingOnly"></v-switch>
                                                </span>
                                                <span style="width:300px;">
                                                    <v-select
                                                        color="white"
                                                        :items="misWorkflowSeverityOptions"
                                                        class="mx-4"
                                                        multiple
                                                        label="Show severity"
                                                        v-model="misWorkflowSeverity">
                                                    </v-select>
                                                </span>
                                                <span style="width:300px;"><v-text-field class="mr-4" clearable v-model="misSearch" type="text"
                                                                                         :label="'Keyword filter'|translate"></v-text-field></span>
                                            </v-layout>
                                            <v-data-table
                                                :headers="integrityHeaders"
                                                :items="refinedMisIssues"
                                                :search="misSearch2"
                                                :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                                                :items-per-page="25"
                                            >
                                                <template v-slot:items="props">
                                                    <td>{{ props.item.equipment_name }}</td>
                                                    <td>{{ props.item.sensor_name }}</td>
                                                    <td><v-chip :color="getColor(props.item.severity)" style="color:#404040 !important;">
                                                        {{ props.item.severity }}
                                                    </v-chip></td>
                                                    <td>{{ props.item.equipment_type }}</td>
                                                    <td>{{ props.item.floor }}</td>
                                                    <td class="pa-0">
                                                        <v-textarea class="pa-0 ma-0 no-field-underline"
                                                            v-model="props.item.notes"
                                                            :clearable="true"
                                                            :rows="1"
                                                            :auto-grow="true"
                                                            ></v-textarea>
                                                    </td>
                                                    <td>
                                                        {{ props.item.status }}
                                                    </td>
                                                    <td>
                                                        <v-tooltip bottom v-if="props.item.status==='pending'">
                                                            <template v-slot:activator="{ on }" >
                                                                <v-icon small v-on="on" class="cursor-as-pointer"  @click="props.item.status='done'">fa-check</v-icon>
                                                            </template>
                                                            <span>{{'Mark as done'|translate}}</span>
                                                        </v-tooltip>
                                                        <v-tooltip bottom v-if="props.item.status==='done'">
                                                            <template v-slot:activator="{ on }" >
                                                                <v-icon small v-on="on" class="cursor-as-pointer"  @click="props.item.status='pending'">fa-bell</v-icon>
                                                            </template>
                                                            <span>{{'Mark as pending'|translate}}</span>
                                                        </v-tooltip>
                                                        <v-tooltip bottom v-if="props.item.canCalc">
                                                            <template v-slot:activator="{ on }">
                                                                <v-icon small v-on="on" class="ml-2 cursor-as-pointer"
                                                                        @click="addToMisItem(props.item)">fa-calculator
                                                                </v-icon>
                                                            </template>
                                                            <span>{{ 'Create as calculated point'|translate }}</span>
                                                        </v-tooltip>
                                                        <v-tooltip bottom v-if="props.item.canBeWritable&&writableConnector">
                                                            <template v-slot:activator="{ on }">
                                                                <v-icon small v-on="on" class="ml-2 cursor-as-pointer"
                                                                        @click="addWritableToMisItem(props.item)">fa-plus
                                                                </v-icon>
                                                            </template>
                                                            <span>{{ 'Create as writable point'|translate }}</span>
                                                        </v-tooltip>

                                                    </td>
                                                </template>
                                            </v-data-table>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn @click="addToAllMisItems" :disabled="!canCreateAllCalc"><v-icon small class="mr-2">fa-calculator</v-icon>{{'Add all missing calculated points'|translate}}</v-btn>
                                            <v-btn @click="addWritableToAllMisItems" :disabled="!canCreateAllWritable" v-if="writableConnector"><v-icon small class="mr-2">fa-plus</v-icon>{{'Add all missing writable points'|translate}}</v-btn>
                                            <v-btn @click="closeMisDialog">{{'Done'|translate}}</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-dialog v-model="recalcDiag" :max-width="600">
                                    <v-card v-if="recalcDiag">
                                        <v-card-title class="primary white--text title">
                                            {{'Recalculate Multiple Calculated Points'|translate}}
                                        </v-card-title>
                                        <v-card-text>
                                            <v-autocomplete v-model="recalcName" :label="'Sensor Name'|translate" :items="calcPointNameFilterOptions"></v-autocomplete>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn class="primary" @click="runMultiRecalc" :disabled="!$can('update', 'Points')||!recalcName">{{'Recalculate for all matching points'|translate}}</v-btn>
                                            <v-btn @click="recalcDiag=false">{{'Cancel'|translate}}</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-layout>

                        </v-card-title>
                        <v-card-text :style="'overflow-y: auto; overflow-x: auto; max-height: ' +blockHeight+'px;'">
                            <v-layout row>
                                <v-text-field class="mt-0 pt-0" prepend-icon="fa-filter" :placeholder="'Filter'|translate" v-model="search" clearable single-line/>
                            </v-layout>
                            <v-divider></v-divider>
                            <v-treeview :search="search2"
                                        :items="cleanedTree"
                                        :filter="customSearch"
                                        :open.sync="open"
                                        item-key="id"
                            >
                                <template v-slot:label="{ item }">
                                    <span class="cursor-as-pointer pa-1" v-bind:class="{ 'v-treeview-node--active': selectedID&&selectedID===item.id }" @click="handleClick(item)">{{item.name}}
                                        <span v-if="debugMode&&item.itemType==='equipment'" v-html="getItemDebugStatus(item)"></span>
                                    </span>
                                </template>
                            </v-treeview>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex md8>
                    <v-card v-if="selectedItem" class="ml-3">
                        <v-card-title class="headline primary white--text" v-if="selectedType==='equipment'">
                            <v-icon small class="mr-2">fa-server</v-icon> {{selectedItem.equipment_name}}
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }" >
                                    <v-icon small v-on="on" class="mr-3 cursor-as-pointer" v-if="$can('update', 'Points')" @click="dialog2=true">fa-plus</v-icon>
                                </template>
                                <span>{{'Add Point'|translate}}</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }" >
                                    <v-icon small v-on="on" class="mr-3 cursor-as-pointer" v-if="$can('update', 'Equipment')" @click="dialog=true">fa-edit</v-icon>
                                </template>
                                <span>{{'Edit Equipment'|translate}}</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }" >
                                    <v-icon small v-on="on" class="mr-2 cursor-as-pointer" v-if="$can('update', 'Equipment')" @click="deleteEquipment(selectedItem)">fa-trash</v-icon>
                                </template>
                                <span>{{'Delete Equipment'|translate}}</span>
                            </v-tooltip>
                            <equipment-record-dialog v-if="$can('update', 'Equipment')" v-model="dialog" :item="selectedItem" v-on:reloadequipments="reloadTree"></equipment-record-dialog>
                            <point-record-dialog v-if="$can('update', 'Points')" v-model="dialog2" :item="{'facility_name': facilityName,'equipment_name':selectedItem.equipment_name}" v-on:reloadpoints="reloadTree"></point-record-dialog>
                        </v-card-title>
                        <v-card-title class="headline primary white--text" v-if="selectedType==='sensor'">
                            <v-icon small class="mr-2">fa-wifi</v-icon> {{selectedItem.equipment_name}} > {{selectedItem.sensor_name}}
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }" >
                                    <v-icon small v-on="on" class="mr-3 cursor-as-pointer" v-if="$can('update', 'Points')" @click="dialog2=true">fa-upload</v-icon>
                                </template>
                                <span>{{'Upload Data'|translate}}</span>
                            </v-tooltip>
                            <v-tooltip bottom v-if="$can('update', 'SoftwareSwitches')&&selectedItem.meta&& selectedItem.meta.tags && selectedItem.meta.tags.includes('writable')">
                                <template v-slot:activator="{ on }" >
                                    <v-icon small v-on="on" class="mr-3 cursor-as-pointer" @click="writeValueDialog=true">fa-pencil-alt</v-icon>
                                </template>
                                <span>{{'Write Value'|translate}}</span>
                            </v-tooltip>
                            <v-tooltip bottom v-if="$can('update', 'Points')&&selectedItem.calculations_statement&&selectedItem.calculations_statement!==''">
                                <template v-slot:activator="{ on }" >
                                    <v-icon small v-on="on" class="mr-3 cursor-as-pointer" @click="runPointRecalc">fa-calculator</v-icon>
                                </template>
                                <span>{{'Recalculate'|translate}}</span>
                            </v-tooltip>
                            <v-tooltip bottom v-if="$can('update', 'Points')&&(!selectedItem.calculations_statement||selectedItem.calculations_statement==='')&&selectedItem.connector_id&&selectedItem.haystack_id">
                                <template v-slot:activator="{ on }" >
                                    <v-icon small v-on="on" class="mr-3 cursor-as-pointer" @click="importJobDialog=true">fa-download</v-icon>
                                </template>
                                <span>{{'Re-import history'|translate}}</span>
                            </v-tooltip>
                            <v-tooltip bottom v-if="$can('update', 'Points')">
                                <template v-slot:activator="{ on }" >
                                    <v-icon small v-on="on" class="mr-3 cursor-as-pointer"  @click="dialog=true">fa-edit</v-icon>
                                </template>
                                <span>{{'Edit Point'|translate}}</span>
                            </v-tooltip>
                            <v-tooltip bottom v-if="$can('update', 'Points')">
                                <template v-slot:activator="{ on }" >
                                    <v-icon small v-on="on" class="mr-2 cursor-as-pointer"  @click="deleteSensor(selectedItem)">fa-trash</v-icon>
                                </template>
                                <span>{{'Delete Point'|translate}}</span>
                            </v-tooltip>
                            <point-record-dialog v-if="$can('update', 'Points')" v-model="dialog" :item="selectedItem" v-on:reloadpoints="reloadTree"></point-record-dialog>
                            <maintenance-upload-dialog
                                v-model="dialog2"
                                v-if="dialog2&&selectedItem"
                                endpoint="/series-upload/"
                                cleanup
                                :sensor-id="selectedItem.sensor_id"
                                v-on:doreload="dialog2=false;"
                                :title="'Upload data for '+ facilityName+' - '+selectedItem.equipment_name+' - '+selectedItem.sensor_name"
                                :upload-title="'Upload CSV data for '+facilityName+' - '+selectedItem.equipment_name+' - '+selectedItem.sensor_name"
                            >
                            </maintenance-upload-dialog>
                            <v-dialog v-model="importJobDialog" :max-width="600">
                                <v-card v-if="importJobDialog&&selectedItem">
                                    <v-card-title class="primary white--text title">
                                        {{'Re-import history for '|translate}} {{selectedItem.equipment_name}} - {{selectedItem.sensor_name}}
                                    </v-card-title>
                                    <v-card-text>
                                        <v-layout row wrap>
                                            <v-flex xs12>
                                                <v-text-field type="date"  :label="'Start Date'|translate" v-model="importJobStartDate" ></v-text-field>
                                                <v-text-field type="date"  :label="'End Date'|translate" v-model="importJobEndDate" ></v-text-field>
                                            </v-flex>
                                        </v-layout>

                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="primary" @click="runPointRedump(); importJobDialog=false" :disabled="!importJobStartDate||!importJobEndDate">{{'Create Job'|translate}}</v-btn>
                                        <v-btn @click="importJobDialog=false">{{'Cancel'|translate}}</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                            <v-dialog v-model="writeValueDialog" :max-width="1000">
                                <v-card v-if="writeValueDialog&&selectedItem">
                                    <v-card-title class="primary white--text title">
                                        {{selectedItem.equipment_name}} - {{selectedItem.sensor_name}}
                                    </v-card-title>
                                    <v-card-text>
                                        <v-layout row wrap>
                                            <v-flex xs12 md6 v-if="selectedItem.meta.writable_priority_array">
                                                <ol>
                                                    <li v-for="(item,priority) in selectedItem.meta.writable_priority_array">
                                                        <span v-if="item">{{item.value}}  {{formatElderDate(item.deadline)}}
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-icon small v-on="on" class="ml-3"
                                                                            @click="clearPriority(editedItem.sensor_id,priority+1)">fa-trash</v-icon>
                                                                </template>
                                                                <span>{{ 'Clear & Save'|translate }}</span>
                                                            </v-tooltip>
                                                        </span>
                                                        <span v-if="!item">null</span>
                                                    </li>
                                                </ol>
                                            </v-flex>
                                            <v-flex xs12 :class="selectedItem.meta.writable_priority_array ? 'md6': ''">
                                                <v-text-field :label="'Sensor ID'|translate" v-model="selectedItem.sensor_id" disabled></v-text-field>
                                                <v-text-field :label="'Upstream ID'|translate" v-model="selectedItem.haystack_id" disabled></v-text-field>
                                                <v-text-field :label="'Value'|translate" v-model.number="selectedItem.value" clearable :rules="selectedItem.meta.writable_value_range ? [value => value < selectedItem.meta.writable_value_range[0] || 'Min value is '+selectedItem.meta.writable_value_range[0], value => value > selectedItem.meta.writable_value_range[1] || 'Max value is '+selectedItem.meta.writable_value_range[1]] : []"></v-text-field>
                                                <v-text-field :label="'Priority'|translate" v-model.number="selectedItem.priority"></v-text-field>
                                                <v-text-field :label="'Duration (seconds)'|translate" v-model.number="selectedItem.duration" clearable></v-text-field>
                                            </v-flex>
                                        </v-layout>

                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="primary" @click="updateControl(selectedItem.sensor_id,selectedItem.value,selectedItem.priority,selectedItem.duration)" :disabled="!$can('update', 'SoftwareSwitches')">{{'Save'|translate}}</v-btn>
                                        <v-btn @click="writeValueDialog=false">{{'Cancel'|translate}}</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-card-title>
                        <v-card-text v-if="selectedType==='equipment'">
                            <v-layout row wrap>
                                <v-flex md6>
                                    <p v-if="selectedItem.equipment_id"><strong>{{'Equipment ID'|translate}} : </strong>{{selectedItem.equipment_id}}</p>
                                    <p v-if="selectedItem.equipment_name"><strong>{{'Equipment Name'|translate}} : </strong>{{selectedItem.equipment_name}}</p>
                                    <p v-if="selectedItem.equipment_type"><strong>{{'Equipment Type'|translate}} : </strong>{{selectedItem.equipment_type}}</p>
                                </v-flex>
                                <v-flex md6>
                                    <p v-if="selectedItem.floor"><strong>{{'Floor'|translate}} : </strong>{{selectedItem.floor}}</p>
                                    <p v-if="selectedItem.notes"><strong>{{'Notes'|translate}} : </strong>{{selectedItem.notes}}</p>
                                </v-flex>
                                <v-flex xs12>
                                    <p v-for="calcPoint in calculatedPointRecommendations">
                                        {{'Add calculated point'|translate}} <strong>{{calcPoint.name}}</strong> <v-tooltip bottom>
                                        <template v-slot:activator="{ on }" >
                                            <v-icon small v-on="on" class="ml-3 cursor-as-pointer" v-if="$can('update', 'Points')" @click="addPointToCurrent(calcPoint.name,calcPoint.formula)">fa-plus-square</v-icon>
                                        </template>
                                        <span>{{'Add as calculated point'|translate}}</span>
                                    </v-tooltip>
                                    </p>
                                </v-flex>
                                <v-flex xs12 v-if="debugMode">
                                    <v-alert v-for="integIssue in equipmentIntegrityIssues"
                                        :value="true"
                                        :color="integIssue.status"
                                             style="padding: 6px;"
                                    >
                                        {{ integIssue.description }}
                                        <v-chip v-for="missingThing in integIssue.sensors">{{missingThing}}</v-chip>
                                    </v-alert>
                                </v-flex>
                            </v-layout>
                            <data3-chart v-for="plot in plotConfig"
                                         :layout-overrides="plot['layout-overrides']"
                                         :on-only="false"
                                         :x-axis="plot['x-axis']"
                                         :y-axis="plot['y-axis']"
                                         :color-axis="plot['color-axis']"
                                         :color-axis-scale="plot['color-axis-scale']"
                                         :color-axis-title="plot['color-axis-title']"
                                         disable-responsive
                                         show-units
                                         :data-payload="plot['data-payload']"
                                         :series-overrides="plot['series-overrides']"
                                         :date-range="range"></data3-chart>
                        </v-card-text>
                        <v-card-text v-if="selectedType==='sensor'">
                            <v-layout>
                                <v-flex md6>
                                    <p v-if="selectedItem.sensor_id"><strong>{{'Sensor ID'|translate}} : </strong>{{selectedItem.sensor_id}}</p>
                                    <p v-if="selectedItem.sensor_name"><strong>{{'Sensor Name'|translate}} : </strong>{{selectedItem.sensor_name}}</p>
                                    <p v-if="selectedItem.sensor_name_abbr"><strong>{{'Sensor Name Abbr'|translate}} : </strong>{{selectedItem.sensor_name_abbr}}</p>
                                    <p v-if="selectedItem.equipment_name"><strong>{{'Equipment Name'|translate}} : </strong>{{selectedItem.equipment_name}}</p>
                                    <p v-if="selectedItem.unit"><strong>{{'Unit'|translate}} : </strong>{{selectedItem.unit}}</p>
                                </v-flex>
                                <v-flex md6>
                                    <p><strong>{{'Faulty'|translate}} : </strong> {{selectedItem.faulty ? 'yes' : 'no'|translate}}</p>
                                    <p v-if="selectedItem.connector_id"><strong>{{'Connector'|translate}} : </strong>{{getConnectorInfo(selectedItem.connector_id)}}</p>
                                    <p v-if="selectedItem.haystack_id"><strong>{{'Upstream ID'|translate}} : </strong>{{selectedItem.haystack_id}}</p>
                                    <p v-if="selectedItem.sensor_desc"><strong>{{'Sensor Description'|translate}} : </strong>{{selectedItem.sensor_desc}}</p>
                                    <p v-if="selectedItem.weight"><strong>{{'Weight'|translate}} : </strong>{{selectedItem.weight}}</p>
                                </v-flex>
                            </v-layout>
                            <data3-chart v-if="plotConfig"
                                         :layout-overrides="plotConfig['layout-overrides']"
                                         :on-only="false"
                                         :x-axis="plotConfig['x-axis']"
                                         :y-axis="plotConfig['y-axis']"
                                         :color-axis="plotConfig['color-axis']"
                                         :color-axis-scale="plotConfig['color-axis-scale']"
                                         :color-axis-title="plotConfig['color-axis-title']"
                                         disable-responsive
                                         show-units
                                         :data-payload="plotConfig['data-payload']"
                                         :series-overrides="plotConfig['series-overrides']"
                                         :date-range="range"></data3-chart>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex xs6 v-if="showConnectors">
            <connectors class="ml-3" side-mode :mappedext="mappedIds" :equipment-name="selectedItem&&selectedItem.equipment_name ? selectedItem.equipment_name : null" @addpoint="addFromConnector"></connectors>
            <point-record-dialog v-if="$can('update', 'Points')" v-model="dialog3" :item="itemFromConnector" v-on:reloadpoints="reloadTree"></point-record-dialog>
        </v-flex>
    </v-layout>
</template>

<script>
import {
    getEquipment,
    deleteEquipment,
    getPoint,
    deletePoint,
    sortFloors,
    getConnector,
    putOptimizationControl,
    putPoint, putJob, getEquipmentRelationship, putEquipmentRelationship, putResult, getResult
} from '../helper'
import EquipmentRecordDialog from '../components/equipment/EquipmentRecordDialog'
import PointRecordDialog from '../components/points/PointRecordDialog'
import Data3Chart from "../components/Data3Chart";
import DateRangeSelector from "../components/DateRangeSelector";
import moment from 'moment'
import MaintenanceUploadDialog from "../components/maintenance/MaintenanceUploadDialog";
import Connectors from "./Connectors";
import calculatedDef from '../config/pointMapping/calculated'
import autoRef from '../config/pointMapping/autoref'
import integrity from '../config/pointMapping/integrity'
import {mapGetters} from "vuex";
import _ from "lodash";
import {exportCSV} from "../tocsv";
import ValueBox from "../components/ValueBox.vue";

export default {
    name: 'Builder',
  components: { EquipmentRecordDialog, PointRecordDialog,Data3Chart,DateRangeSelector,MaintenanceUploadDialog,Connectors,ValueBox},
    data() {
        return {
      loading: true,
      open:[],
      search:null,
      search2:null,
            misSearch: null,
            misSearch2: null,
      misWorkflowDialog:false,
      misWorkflowSeverity:['critical','important'],
      misWorkflowSeverityOptions:['critical','important','optional'],
      misPendingOnly:true,
      misIssues:[],
      completionPercentage:null,
      integrityHeaders: [
          {text: this.$options.filters.translate('Equipment Name'), value: 'equipment_name'},
          {text: this.$options.filters.translate('Sensor Name'), value: 'sensor_name'},
          {text: this.$options.filters.translate('Severity'), value: 'severity'},
          {text: this.$options.filters.translate('Equipment Type'), value: 'equipment_type'},
          {text: this.$options.filters.translate('Floor'), value: 'floor'},
          {text: this.$options.filters.translate('Notes'), value: 'notes',sortable: false},
          {text: this.$options.filters.translate('Status'), value: 'status'},
          {text: this.$options.filters.translate('Actions'), value: 'name', sortable: false},
      ],
      debugMode:false,
      itemFromConnector:null,
      showConnectors:false,
      dialog:false,
      writeValueDialog:false,
            errorColors: {
                'critical': 'error',
                'important': 'warning',
                'optional': 'info',
                'OK': 'green'
            },
      dialog2:false,
      dialog3:false,
      importJobEndDate: null,
      importJobStartDate: null,
      importJobDialog:false,
      uploadDialog:false,
      mappedIds:[],
      multiUploadDialog:false,
      connectors:[],
      equipDialog:false,
      mcpDialog:false,
      mwpDialog:false,
      tree:null,
      timeout:null,
      selectedItem:null,
      selectedID:null,
      selectedType:null,
      selectedItemChildren:null,
      recalcDiag:false,
      recalcName:null,
      allEquipments:[],
      allPoints:[],
      allRelationships:[],
      mcpTypeFilter:null,
      mwpTypeFilter:null,
      mcpFloorFilter:null,
      mwpFloorFilter:null,
      mcpName:null,
      mwpName:null,
      mcpForumla:null,
      mcpEditExisting:false,
      mwpEditExisting:false,
      massCalcCreateFormula:null,
      range: {start: moment().subtract(30, "days").format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD')},
    }},

  mounted() {
    this.reloadTree()
  },
    watch: {
        search() {
            this.debounce(this.syncSearches, 500);
        },
        misSearch() {
            this.debounce(this.syncMisSearches, 500);
        }

    },
    async beforeMount() {
        let maxDate = this.$store.state.pointsListStore.pointsList.data_max_date;
        let rangeStart = _.get(this.$route.query, 'rangeStart', null)
        let rangeEnd = _.get(this.$route.query, 'rangeEnd', null)
        if (!!rangeStart) {
            this.range = {start: rangeStart, end: rangeEnd}
        } else if (maxDate) {
            this.range = {
                start: moment(maxDate).subtract(30, "days").format('YYYY-MM-DD'),
                end: moment(maxDate).format('YYYY-MM-DD')
            }
        }
        let df = await getConnector({
            facility_name: this.$store.state.pointsListStore.pointsList.facility_name
        })
        this.connectors = df['result']
    },
    computed: {
        ...mapGetters([
            'mappingCalculatedConfig','mappingIntegrityConfig','mappingRefConfig',
        ]),
        canCreateAllCalc(){
          if (this.misIssues&&this.misIssues.length>0){
              return this.misIssues.filter(x=>x.canCalc&&x.status==="pending"&&this.misWorkflowSeverity.includes(x.severity)).length>0
          }
          return false
        },
        canCreateAllWritable(){
            if (this.misIssues&&this.misIssues.length>0){
                return this.misIssues.filter(x=>x.canBeWritable&&x.status==="pending"&&this.misWorkflowSeverity.includes(x.severity)).length>0
            }
            return false
        },
        matchingMCPTargets(){
            if (!this.mcpTypeFilter&&!this.mcpFloorFilter){
                return []
            }
            let equips = JSON.parse(JSON.stringify(this.allEquipments))
            if (this.mcpTypeFilter) {
                equips = equips.filter(x => x.equipment_type === this.mcpTypeFilter)
            }
            if (this.mcpFloorFilter) {
                equips = equips.filter(x => x.floor === this.mcpFloorFilter)
            }
            return equips.map(x=>x.equipment_name)
        },
        matchingMWPTargets(){
            if (!this.mwpTypeFilter&&!this.mwpFloorFilter){
                return []
            }
            let equips = JSON.parse(JSON.stringify(this.allEquipments))
            if (this.mwpTypeFilter) {
                equips = equips.filter(x => x.equipment_type === this.mwpTypeFilter)
            }
            if (this.mwpFloorFilter) {
                equips = equips.filter(x => x.floor === this.mwpFloorFilter)
            }
            return equips.map(x=>x.equipment_name)
        },
        writableConnector(){
            let found=this.connectors.filter(x=>x.type==="writable")
            return found.length>0 ? found[0] : null
        },
        calculatedPointRecommendations(){
            if (this.selectedItem&&this.selectedType==='equipment'){
                let availableOnesDef=this.mappingCalculatedConfig ? this.mappingCalculatedConfig : calculatedDef
                let availableOnes=availableOnesDef.filter(x=>x.equipment_type===this.selectedItem.equipment_type)
                let recs = []
                let equipPoints=this.allPoints.filter(x=>x.equipment_name===this.selectedItem.equipment_name).map(x=>x.sensor_name)
                for (let calcPoint of availableOnes) {
                    if (!equipPoints.includes(calcPoint.name) && calcPoint.requirements.filter(x => !x.includes(" - ")).every(x => equipPoints.includes(x)) && calcPoint.requirements.filter(x => x.includes(" - ")).every(x => this.allPoints.filter(point => point.equipment_name===x.split(" - ")[0]&&point.sensor_name===x.split(" - ")[1]).length>0)) {
                        recs.push(calcPoint)
                    }
                }
                return recs
            }
            return []
        },
        refinedMisIssues(){
            let issues=this.misIssues
            issues=issues.filter(x=>this.misWorkflowSeverity.includes(x.severity))
            if (this.misPendingOnly){
                issues=issues.filter(x=>x.status==="pending")
            } else {
                issues=issues.filter(x=>x.status!=="auto-created")
            }
            return issues
        },
        equipmentIntegrityIssues() {
            if (this.debugMode&&this.selectedItem && this.selectedType === 'equipment') {
                let integrityConfig = this.mappingIntegrityConfig ? this.mappingIntegrityConfig : integrity
                let issuesForType = integrityConfig.filter(x => x.equipmentGroup === this.selectedItem.equipment_type)
                let issues = []
                let equipPoints=this.allPoints.filter(x=>x.equipment_name===this.selectedItem.equipment_name).map(x=>x.sensor_name)
                let interityIssue = {
                    missingCriticalSensors: issuesForType.filter(x => x.importance === "critical").map(x => x.carnotname).filter(x => !equipPoints.includes(x)),
                    missingImportantSensors: issuesForType.filter(x => x.importance === "important").map(x => x.carnotname).filter(x => !equipPoints.includes(x)),
                    missingOptionalSensors: issuesForType.filter(x => x.importance === "optional").map(x => x.carnotname).filter(x => !equipPoints.includes(x)),
                }
                if (interityIssue.missingCriticalSensors.length > 0) {
                    issues.push({
                        description: this.$options.filters.translate("Missing critical sensors: "),
                        sensors:interityIssue.missingCriticalSensors,
                        status: "error"
                    })

                } else if (interityIssue.missingImportantSensors.length > 0) {
                    issues.push({
                        description: this.$options.filters.translate("Missing important sensors: "),
                        sensors:interityIssue.missingImportantSensors,
                        status: "warning"
                    })
                } else if (interityIssue.missingOptionalSensors.length > 0) {
                    issues.push({
                        description: this.$options.filters.translate("Missing optional sensors: "),
                        sensors:interityIssue.missingOptionalSensors,
                        status: "info"
                    })
                }
                return issues
            }
            return []
        },
        canSwitchToDebug() {
            if (this.$store.state.userStore.user) {
                if (process.env.VUE_APP_EXTERNAL_AUTH&&process.env.VUE_APP_EXTERNAL_AUTH==="msal"&&this.$store.state.userStore.user.content.role==="admin"){
                    return true
                } else if (process.env.VUE_APP_SUPERUSER&&process.env.VUE_APP_SUPERUSER!==""){
                    return this.$store.state.userStore.user.content.user_name.toLowerCase().includes(process.env.VUE_APP_SUPERUSER)
                } else {
                    return this.$store.state.userStore.user.content.user_name === "jecdavid" || this.$store.state.userStore.user.content.user_name.toLowerCase().includes("carnot")
                }
            }
            return false;
        },
        equipTypeFilterOptions(){
            return JSON.parse(JSON.stringify([...new Set(this.allEquipments.filter(x=>x.equipment_type).map(x=>x.equipment_type))])).sort()
        },
        equipFloorFilterOptions(){
            return JSON.parse(JSON.stringify([...new Set(this.allEquipments.filter(x=>x.floor).map(x=>x.floor))])).sort()
        },
        calcPointNameFilterOptions(){
            return JSON.parse(JSON.stringify([...new Set(this.allPoints.filter(x=>x.sensor_name&&x.calculations_statement&&x.calculations_statement!=="").map(x=>x.sensor_name))])).sort()
        },
        facilityName(){
            return this.$store.state.pointsListStore.pointsList.facility_name;
        },
        blockHeight(){
          return window.innerHeight-100
        },
        cleanedTree() {
            return JSON.parse(JSON.stringify(this.tree)) //this is just here to scrap observers and not kill tree performance
        },
        plotConfig(){
            if (this.selectedType&&this.selectedType==='sensor'){
                return  {
                    'layout-overrides': {
                        title:"",
                        colorway: ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf'],
                        xaxis: {
                            title: this.$options.filters.translate("Time")
                        },
                        yaxis: {
                            title: this.selectedItem.unit
                        },
                        zaxis: {
                            title: null
                        },
                        showlegend:true,
                        height:300,
                        hovermode:"x",
                        margin:{
                            l: 50,
                            r: 50,
                            t: 50,
                            pad: 1
                        },
                        legend: {
                            orientation: 'h',
                            y: -0.3
                        },
                    },
                    "x-axis":"timestamp",
                    "y-axis":null,
                    "color-axis":null,
                    "color-axis-scale":null,
                    "color-axis-title":null,
                    'data-payload': [{
                        'filters': {
                            equipment_name: this.selectedItem.equipment_name,
                            sensor_name: this.selectedItem.sensor_name,
                            facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                        },
                        seriesOverrides:{
                            type:'scatter',
                            opacity:1,
                            xbins: {
                                size: 1
                            },
                            ybins: {
                                size: 1
                            }
                        },
                    }],
                }
            } else if (this.selectedType&&this.selectedType==='equipment'&&this.selectedItemChildren){
                let newVarList={};
                for (let sensor of this.selectedItemChildren){
                    let unit = sensor.itemData.unit ? sensor.itemData.unit : ""
                    if (!newVarList[unit]) {
                        newVarList[unit] = [];
                    }
                    newVarList[unit].push({
                        equipment_name: this.selectedItem.equipment_name,
                        name: sensor.itemData.sensor_name,
                        facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                    })
                }
                return(Object.keys(newVarList).map(unit=>{
                    return  {
                        'layout-overrides': {
                            title:"",
                            colorway: ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf'],
                            xaxis: {
                                title: this.$options.filters.translate("Time")
                            },
                            yaxis: {
                                title: unit
                            },
                            zaxis: {
                                title: null
                            },
                            showlegend:true,
                            height:300,
                            hovermode:"x",
                            margin:{
                                l: 50,
                                r: 50,
                                t: 50,
                                pad: 1
                            },
                            legend: {
                                orientation: 'h',
                                y: -0.3
                            },
                        },
                        "x-axis":"timestamp",
                        "y-axis":null,
                        "color-axis":null,
                        "color-axis-scale":null,
                        "color-axis-title":null,
                        'data-payload': newVarList[unit].map(function (selectedVar) {
                            let premap={
                                'filters': {
                                    equipment_name: selectedVar.equipment_name,
                                    sensor_name: selectedVar.name,
                                    facility_name: selectedVar.facility_name,
                                },
                                seriesOverrides:{
                                    type:'scatter',
                                    opacity:1,
                                    xbins: {
                                        size: 1
                                    }
                                },
                                pipeline:[]
                            }

                            return (premap)
                        }),
                    }
                }))
            } else {
                return null
            }
        }
    },
    methods: {
        exportPoints() {
            let cleanedItems = JSON.parse(JSON.stringify(this.allPoints))
            exportCSV(cleanedItems.map(item => this.formatItem(item)))
        },
        formatItem(item) {
            let equipment = this.allEquipments.filter(x => x.equipment_id === item.equipment_id)[0]
            return {
                sensor_id: item.sensor_id ? item.sensor_id : "",
                upstream_id: item.haystack_id ? item.haystack_id : "",
                site: item.facility_name ? item.facility_name : "",
                equip: item.equipment_name ? item.equipment_name : "",
                equip_type: equipment&&equipment.equipment_type ? equipment.equipment_type : "",
                equip_tags: equipment&&equipment.equipment_tags ? JSON.stringify(equipment.equipment_tags) : "[]",
                meta: item.meta ? JSON.stringify(item.meta) : "{}",
                upstream_sensor_name: item.sensor_name_abbr ? item.sensor_name_abbr : item.sensor_name,
                sensor_name: item.sensor_name ? item.sensor_name : "",
                unit: item.unit ? item.unit : "",
                floor: equipment&&equipment.floor ? equipment.floor : "",
                equip_meta: equipment&&equipment.meta ? JSON.stringify(equipment.meta) : "{}",
                sensor_desc: item.sensor_desc ? item.sensor_desc : "",
                connector_id: item.connector_id ? item.connector_id : "",
                calculations_statement: item.calculations_statement ? item.calculations_statement : "",
            }
        },
        formatElderDate(date){
            return moment(date).format('YYYY-MM-DD HH:mm:ss')
        },
        customSearch(item, text) {
            return (item.name && item.name.toLowerCase().indexOf(text.toLowerCase()) > -1) || (item.itemData && item.itemData.sensor_desc && item.itemData.sensor_desc.toLowerCase && item.itemData.sensor_desc.toLowerCase().indexOf(text.toLowerCase()) > -1 || (item.itemData && item.itemData.haystack_id && item.itemData.haystack_id.toLowerCase().indexOf(text.toLowerCase()) > -1))
        },
        getColor(x) {
            return _.get(this.errorColors, x.toLowerCase(), 'green')
        },
        async autoBuildRelationships(){
            let autoRefConfig = this.mappingRefConfig ? this.mappingRefConfig : autoRef
            let incr=0
            for (let item of autoRefConfig){
                let equip1s=this.allEquipments.filter(x=>x.equipment_type===item.equip1_type)
                for (let equip1 of equip1s){
                    let equip2s=this.allEquipments.filter(x=>x.equipment_type===item.equip2_type&&x.floor===equip1.floor)
                    for (let equip2 of equip2s){
                        if (this.allRelationships.filter(x=>x.type===item.type&&x.equip1===equip1.equipment_id&&x.equip2===equip2.equipment_id).length===0){
                            await putEquipmentRelationship(
                                {
                                    type:item.type,
                                    equip1:equip1.equipment_id,
                                    equip2:equip2.equipment_id,
                                    facility_name:this.facilityName
                                })
                            incr++
                        }
                    }
                }
            }
            this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('Done. Equipment relationships created: ')+incr})
        },
        getItemDebugStatus(item){
            let integrityConfig = this.mappingIntegrityConfig ? this.mappingIntegrityConfig : integrity
            let issuesForType = integrityConfig.filter(x => x.equipmentGroup === item.itemData.equipment_type)
            let equipPoints=this.allPoints.filter(x=>x.equipment_name===item.itemData.equipment_name).map(x=>x.sensor_name)
            if(issuesForType.filter(x => x.importance === "critical").map(x => x.carnotname).filter(x => !equipPoints.includes(x)).length>0){
                return '<span class="ml-2 error--text"><strong>&#x26A0;</strong></span>'
            } else if(issuesForType.filter(x => x.importance === "important").map(x => x.carnotname).filter(x => !equipPoints.includes(x)).length>0){
                return '<span class="ml-2 warning--text"><strong>&#x26A0;</strong></span>'
            }
            return null
        },
        async addPointToCurrent(pointName,pointFormula){
            if (this.selectedItem&&this.selectedType==='equipment'){
                await this.autoCreatePoints([this.selectedItem],pointName,pointFormula)
                this.reloadTree()
            }
        },
        async addToMisItem(item){
            await this.autoCreatePoints([item],item.sensor_name,item.formula,false)
            item.status="auto-created"
        },
        async addWritableToMisItem(item){
            await this.autoCreateWritablePoints([item],item.sensor_name,this.writableConnector.connector_id,false)
            item.status="auto-created"
        },
        async closeMisDialog(){
            await putResult({
                'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                'content': this.misIssues.filter(x=>x.status==="done"||(x.notes&&x.notes!=="")),
                'result_name': 'MappingIntegrityIssues',
                'description': ''
            })
            this.misWorkflowDialog=false
            await this.reloadTree()
        },
        async addToAllMisItems(){
            let incr=0
            for (let item of this.misIssues){
                if (item.canCalc&&item.status==="pending"&&this.misWorkflowSeverity.includes(item.severity)){
                    await this.autoCreatePoints([item],item.sensor_name,item.formula,false,true)
                    item.status="auto-created"
                    incr++
                }
            }
            this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('Done. Points created: ')+incr})
        },
        async addWritableToAllMisItems(){
            let incr=0
            for (let item of this.misIssues){
                if (item.canBeWritable&&item.status==="pending"&&this.misWorkflowSeverity.includes(item.severity)){
                    await this.autoCreateWritablePoints([item],item.sensor_name,this.writableConnector.connector_id,false,true)
                    item.status="auto-created"
                    incr++
                }
            }
            this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('Done. Points created: ')+incr})
        },
        async autoCreatePoints(equips,pointName,pointFormula,doAlert=false,quiet=false,editExisting=false){
            let incr=0
            let incrEdit=0
            let exceptioAlreadyExists=[]
            let exceptionMissing=[]
            for (let equip of equips) {
                if (editExisting||this.allPoints.filter(x => x.equipment_name === equip.equipment_name && x.sensor_name === pointName).length === 0) {
                    let formula=pointFormula
                    let canWrite=true
                    if (formula&&formula!=="") {
                        let tbr = formula.match(/df\[(.*?)\]/g)
                        if (tbr) {
                            for (let item of tbr) {
                                if (item.startsWith('df[[')) {
                                    let itemCenters = item.split('[[')[1].split(']')[0].split(',')
                                    let newCenters = []
                                    for (let itemCenterShell of itemCenters) {
                                        let equipName=equip.equipment_name
                                        let iCName=itemCenterShell.split('"')[1].split(" - ")[0]
                                        let itemCenter = itemCenterShell.split('"')[1].split(" - ")[1]
                                        if (iCName!==""&&iCName!==equipName&&iCName!=="equipment"&&iCName!=="equip"){
                                            equipName=iCName
                                        }
                                        let foundItems = this.allPoints.filter(x => x.equipment_name === equipName && x.sensor_name === itemCenter)
                                        if (foundItems.length < 1) {
                                            console.log("No sensor found for " + equipName + " - " + itemCenter);
                                            canWrite = false
                                        } else {
                                            newCenters.push(foundItems[0].sensor_id)
                                        }
                                    }
                                    if (itemCenters.length === newCenters.length) {
                                        formula = formula.replace(item, 'df[[' + newCenters.join(',') + ']')
                                    }
                                } else {
                                    let itemCenterShell = item.split('[')[1].split(']')[0]
                                    let itemCenter = itemCenterShell.split('"')[1].split(" - ")[1]
                                    if (itemCenter) {
                                        let equipName=equip.equipment_name
                                        let iCName=itemCenterShell.split('"')[1].split(" - ")[0]
                                        if (iCName!==""&&iCName!==equipName&&iCName!=="equipment"&&iCName!=="equip"){
                                            equipName=iCName
                                        }
                                        let foundItems = this.allPoints.filter(x => x.equipment_name === equipName && x.sensor_name === itemCenter)
                                        if (foundItems.length < 1) {
                                            console.log("No sensor found for " + equipName + " - " + itemCenter);
                                            canWrite = false
                                        } else {
                                            formula = formula.replace(item, 'df[' + foundItems[0].sensor_id + ']')
                                        }
                                    }
                                }

                            }
                        }
                    }
                    if (canWrite){
                        let newPoint = {
                            sensor_id: null,
                            connector_id: null,
                            sensor_name: pointName,
                            sensor_name_abbr: '',
                            sensor_desc: '',
                            unit:  '',
                            haystack_id: null,
                            faulty:false,
                            weight:1,
                            equipment_name: equip.equipment_name,
                            meta: '',
                            facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                            calculations_statement: formula,
                        }
                        if (editExisting&&this.allPoints.filter(x => x.equipment_name === equip.equipment_name && x.sensor_name === pointName).length>0){
                            newPoint=JSON.parse(JSON.stringify(this.allPoints.filter(x => x.equipment_name === equip.equipment_name && x.sensor_name === pointName)[0]))
                            if (!newPoint.connector_id&&!newPoint.haystack_id&&newPoint.calculations_statement===formula){
                                continue
                            }
                            newPoint.calculations_statement=formula
                            newPoint.haystack_id=null
                            newPoint.connector_id=null
                            if (newPoint.meta&&newPoint.meta.tags&&newPoint.meta.tags.includes("writable")){
                                newPoint.meta.tags=newPoint.meta.tags.filter(x=>x!=="writable")
                            }
                            incrEdit++
                        } else {
                            incr++
                        }
                        await putPoint(newPoint)
                    } else {
                        exceptionMissing.push(equip.equipment_name)
                    }
                } else {
                    exceptioAlreadyExists.push(equip.equipment_name)
                }
            }
            if (doAlert){
                let message = this.$options.filters.translate('Done. Points created: ')+incr
                if (incrEdit>0){
                    message+="\n"+this.$options.filters.translate('Points edited: ')+incrEdit
                }
                if (exceptioAlreadyExists.length>0){
                    message+="\n"+this.$options.filters.translate('Points already exists for: ')+exceptioAlreadyExists.join(', ')
                }
                if (exceptionMissing.length>0){
                    message+="\n"+this.$options.filters.translate('Points could not be created for: ')+exceptionMissing.join(', ')
                }
                alert(message)
            } else if (!quiet){
                this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('Done. Points created: ')+incr})
            }
        },
        async autoCreateWritablePoints(equips, pointName, connectorId, doAlert = false, quiet = false, editExisting = false) {
            let incr = 0
            let incrEdit = 0
            let exceptioAlreadyExists = []
            for (let equip of equips) {
                if (editExisting || this.allPoints.filter(x => x.equipment_name === equip.equipment_name && x.sensor_name === pointName).length === 0) {
                    let newPoint = {
                        sensor_id: null,
                        connector_id: connectorId,
                        sensor_name: pointName,
                        sensor_name_abbr: '',
                        sensor_desc: '',
                        unit: '',
                        haystack_id: null,
                        faulty: false,
                        weight: 1,
                        equipment_name: equip.equipment_name,
                        meta: {tags: ["writable"]},
                        facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                        calculations_statement: null,
                    }
                    if (equip.canBeWritable&&typeof(equip.writableDefaultValue)!=="undefined"){
                        newPoint.meta.writable_default_value=equip.writableDefaultValue
                    }
                    if (editExisting && this.allPoints.filter(x => x.equipment_name === equip.equipment_name && x.sensor_name === pointName).length > 0) {
                        newPoint = JSON.parse(JSON.stringify(this.allPoints.filter(x => x.equipment_name === equip.equipment_name && x.sensor_name === pointName)[0]))
                        if (newPoint.connector_id === connectorId&&newPoint.meta&&newPoint.meta.tags&&newPoint.meta.tags.includes("writable")) {
                            continue
                        }
                        newPoint.connector_id = connectorId
                        newPoint.calculations_statement = null
                        if (!newPoint.meta||newPoint.meta===""){
                            newPoint.meta = {tags: ["writable"]}
                        } else if (!newPoint.meta.tags) {
                            newPoint.meta.tags = ["writable"]
                        } else if (!newPoint.meta.tags.includes("writable")) {
                            newPoint.meta.tags.push("writable")
                        }
                        if (equip.canBeWritable&&typeof(equip.writableDefaultValue)!=="undefined"){
                            newPoint.meta.writable_default_value=equip.writableDefaultValue
                        }
                        incrEdit++
                    } else {
                        incr++
                    }
                    let createdPoint = await putPoint(newPoint)
                    if (equip.canBeWritable&&typeof(equip.writableDefaultValue)!=="undefined"){
                        await putOptimizationControl({
                            'sensor_id': createdPoint.record.sensor_id,
                            'value': equip.writableDefaultValue,
                            'priority': 8,
                        })
                    }
                } else {
                    exceptioAlreadyExists.push(equip.equipment_name)
                }
            }
            if (doAlert) {
                let message = this.$options.filters.translate('Done. Points created: ') + incr
                if (incrEdit > 0) {
                    message += "\n" + this.$options.filters.translate('Points edited: ') + incrEdit
                }
                if (exceptioAlreadyExists.length > 0) {
                    message += "\n" + this.$options.filters.translate('Points already exists for: ') + exceptioAlreadyExists.join(', ')
                }
                alert(message)
            } else if (!quiet) {
                this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('Done. Points created: ') + incr})
            }
        },
        async runMCP() {
            if (this.mcpName && this.mcpName !== "") {
                let equips = JSON.parse(JSON.stringify(this.allEquipments))
                if (this.mcpTypeFilter) {
                    equips = equips.filter(x => x.equipment_type === this.mcpTypeFilter)
                }
                if (this.mcpFloorFilter) {
                    equips = equips.filter(x => x.floor === this.mcpFloorFilter)
                }
                this.loading=true
                this.mcpDialog=false
                await this.autoCreatePoints(equips,this.mcpName,this.mcpForumla,true,false,this.mcpEditExisting)
                this.reloadTree()
            }
        },
        async runMWP() {
            if (this.mwpName && this.mwpName !== ""&&this.writableConnector&&this.writableConnector.connector_id) {
                let equips = JSON.parse(JSON.stringify(this.allEquipments))
                if (this.mwpTypeFilter) {
                    equips = equips.filter(x => x.equipment_type === this.mwpTypeFilter)
                }
                if (this.mwpFloorFilter) {
                    equips = equips.filter(x => x.floor === this.mwpFloorFilter)
                }
                this.loading=true
                this.mwpDialog=false
                await this.autoCreateWritablePoints(equips,this.mwpName,this.writableConnector.connector_id,true,false,this.mwpEditExisting)
                this.reloadTree()
            }
        },
        async runMIS(){
            let existingIssues=[]
            let existingResult=await getResult({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                result_name: 'MappingIntegrityIssues'
            })
            if(existingResult&&existingResult.result.length>0){
                existingIssues=existingResult.result[0].content
            }
            let equips = JSON.parse(JSON.stringify(this.allEquipments))
            equips=equips.filter(x=>x.floor&&!x.floor.toLowerCase().startsWith("backup")&&!x.floor.toLowerCase().startsWith(".backup"))
            let foundIssues=[]
            let integrityConfig = this.mappingIntegrityConfig ? this.mappingIntegrityConfig : integrity
            let availableCalcDef=this.mappingCalculatedConfig ? this.mappingCalculatedConfig : calculatedDef
            let totalPriorityPoints=0
            let totalPriorityIssues=0
            for (let equip of equips){
                let issuesForType = integrityConfig.filter(x => x.equipmentGroup === equip.equipment_type)
                let equipPoints=this.allPoints.filter(x=>x.equipment_name===equip.equipment_name).map(x=>x.sensor_name)
                let interityIssue = {
                    critical: issuesForType.filter(x => x.importance === "critical").map(x => x.carnotname).filter(x => !equipPoints.includes(x)),
                    important: issuesForType.filter(x => x.importance === "important").map(x => x.carnotname).filter(x => !equipPoints.includes(x)),
                    optional: issuesForType.filter(x => x.importance === "optional").map(x => x.carnotname).filter(x => !equipPoints.includes(x)),
                }
                totalPriorityPoints=totalPriorityPoints+issuesForType.filter(x => x.importance === "critical"|| x.importance === "important").length
                let availableCalcPoints=availableCalcDef.filter(x=>x.equipment_type===equip.equipment_type)
                for (let severity in interityIssue) {
                    for (let missingSensor of interityIssue[severity]) {
                        let issue={
                            severity: severity,
                            equipment_name: equip.equipment_name,
                            equipment_type: equip.equipment_type,
                            floor: equip.floor,
                            sensor_name: missingSensor,
                            canCalc:false,
                            canBeWritable:false,
                            formula:null,
                            status:"pending",
                            notes:null
                        }
                        let foundCalcDef=availableCalcPoints.filter(x=>x.name===missingSensor)
                        if (foundCalcDef.length>0&&foundCalcDef[0].requirements.filter(x => !x.includes(" - ")).every(x => equipPoints.includes(x)) && foundCalcDef[0].requirements.filter(x => x.includes(" - ")).every(x => this.allPoints.filter(point => point.equipment_name===x.split(" - ")[0]&&point.sensor_name===x.split(" - ")[1]).length>0)){
                            issue.formula=foundCalcDef[0].formula
                            issue.canCalc=true
                        }
                        let correspondingDef=issuesForType.filter(x => x.carnotname === missingSensor)[0]
                        if (correspondingDef&&correspondingDef.writable){
                            issue.canBeWritable=true
                            if (typeof(correspondingDef.writableDefaultValue)!=="undefined"){
                                issue.writableDefaultValue=correspondingDef.writableDefaultValue
                            }
                        }
                        let existingIssue=existingIssues.filter(x=>x.equipment_name===equip.equipment_name&&x.sensor_name===missingSensor)
                        if (existingIssue.length>0){
                            issue.notes=existingIssue[0].notes
                            if (existingIssue[0].status==="done"){
                                issue.status="done"
                            }
                        }
                        if ((severity==="critical"||severity==="important")&&issue.status==="pending"){
                            totalPriorityIssues=totalPriorityIssues+1
                        }
                        foundIssues.push(issue)
                    }
                }
            }
            this.misIssues=foundIssues
            this.completionPercentage=Math.round(((totalPriorityPoints-totalPriorityIssues)/totalPriorityPoints)*100)
            this.misWorkflowDialog=true
        },
        async runMultiRecalc() {
            if (this.recalcName&&this.recalcName!==""){
                this.loading=true
                this.recalcDiag=false
                let matchingSensors=this.allPoints.filter(x=>x.sensor_name===this.recalcName&&x.calculations_statement&&x.calculations_statement!==""&&x.equipment_name&&x.equipment_name!=="")
                if (matchingSensors.length>0){
                    let incr=0
                    for (let sensor of matchingSensors) {
                        await putJob({
                            'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                            'job_type': 'Recalculate Calculated Points',
                            'job_status': 'pending',
                            'meta': {
                                'equipment_name - sensor_name': sensor.equipment_name+" - "+sensor.sensor_name,
                            }
                        })
                        incr++
                    }
                    this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('Done. Recalculation jobs created: ')+incr})
                } else {
                    this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('No calculated points found for this name')})
                }
                this.loading=false
            }
        },
        getConnectorInfo(id){
            let found=this.connectors.filter(x=>x.connector_id===id)
            if (found&&found[0]){
                return found[0].type+ " - "+found[0].name
            }
            return id
        },
        addFromConnector(item){
            this.itemFromConnector=item
            this.dialog3=true
        },
        async deleteSensor (sensor) {
            if (confirm(this.$options.filters.translate('Are you sure you want to delete this sensor?')) ){
                await deletePoint({
                    'sensor_id': sensor.sensor_id
                })
                this.clearSelection()
                this.reloadTree()
            }
        },
        async runPointRecalc () {
            if (confirm(this.$options.filters.translate('Are you sure you want to recalculate data for this calculated point?')) ){
                await putJob({
                    'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                    'job_type': 'Recalculate Calculated Points',
                    'job_status': 'pending',
                    'meta': {
                        'equipment_name - sensor_name': this.selectedItem.equipment_name+" - "+this.selectedItem.sensor_name,
                    }
                })
                await this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('Recalculation job requested')})
            }
        },
        async runPointRedump () {
                await putJob({
                    'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                    'job_type': 'import connector his',
                    'job_status': 'pending',
                    'meta': {
                        'sensor_id': this.selectedItem.sensor_id,
                        'end_date':this.importJobEndDate,
                        'start_date':this.importJobStartDate,
                    }
                })
                await this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('History re-import job requested')})
        },
        async deleteEquipment (equipment) {
            if (confirm(this.$options.filters.translate('Are you sure you want to delete this equipment?')) ){
                await deleteEquipment({
                    'equipment_id': equipment.equipment_id
                })
                this.clearSelection()
                this.reloadTree()
            }
        },
        handleClick(item){
            if(!item.itemType||!item.itemData){
                this.clearSelection()
            } else {
                this.selectItem(item.itemType,item.itemData,item.id,item.children)
            }
        },
        selectItem(type,item,id,children){
            this.dialog=false
            this.dialog2=false
            this.selectedType=type
            this.selectedItem=item
            this.selectedItemChildren=children
            this.selectedID=id
        },
        clearSelection(){
            this.dialog=false
            this.dialog2=false
            this.selectedType=null
            this.selectedItem=null
            this.selectedItemChildren=null
            this.selectedID=null
        },
        syncSearches() {
            this.search2 = this.search
        },
        syncMisSearches() {
            this.misSearch2 = this.misSearch
        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
        arrangeIntoTree(paths,childrenList,equipDetails) {
            let tree = [];
            for (let i = 0; i < paths.length; i++) {
                let path = paths[i];
                let currentLevel = tree;
                for (let j = 0; j < path.length; j++) {
                    let part = path[j];
                    let existingPath = this.findWhere(currentLevel, 'name', part);
                    if (existingPath) {
                        currentLevel = existingPath.children;
                    } else {
                        let newPart = {
                            name: part,
                            id: path.join('-')+'-'+part,
                            children: [],
                        }
                        if(equipDetails[part]){
                            newPart.itemType="equipment"
                            newPart.itemData=equipDetails[part]
                        }
                        if(childrenList[part]){
                            newPart.children=childrenList[part]
                        }
                        currentLevel.push(newPart);
                        currentLevel = newPart.children;
                    }
                }
            }
            return tree;
        },
        findWhere(array, key, value) {
            let t = 0;
            while (t < array.length && array[t][key] !== value) {
                t++;
            }
            if (t < array.length) {
                return array[t]
            } else {
                return false;
            }
        },
        async clearPriority(sensor_id,priority){
            await putOptimizationControl({
                'sensor_id': sensor_id,
                'value': null,
                'priority': priority,
            })
            this.writeValueDialog = false
            this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('Update request sent')})
        },
        async updateControl(sensor_id, value, priority,duration) {
            await putOptimizationControl({
                'sensor_id': sensor_id,
                'value': value===""||value==="null" ? null : value,
                'priority': priority&&priority!=="" ? priority : 8,
                'duration':duration,
            })
            this.writeValueDialog = false
            this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('Update request sent')})
        },
      async reloadTree() {
          this.loading=true
          this.dialog=false
          this.dialog2=false
          this.dialog3=false
          let facilityName=this.$store.state.pointsListStore.pointsList.facility_name
          let equipsDF = await getEquipment({
              facility_name: facilityName
          })
          let pointsDF = await getPoint({
              facility_name: facilityName
          })
          let relationshipsDf = await getEquipmentRelationship({
              facility_name: facilityName
          })
          if (this.selectedItem&&this.selectedType){
              if (this.selectedType === "sensor") {
                  this.selectedItem = pointsDF.result.filter(x => x.sensor_id === this.selectedItem.sensor_id)[0]
              } else if (this.selectedType === "equipment") {
                  this.selectedItem = equipsDF.result.filter(x => x.equipment_id === this.selectedItem.equipment_id)[0]
              }
          }
          this.allEquipments=JSON.parse(JSON.stringify(equipsDF.result))
          this.allPoints=JSON.parse(JSON.stringify(pointsDF.result))
          this.allRelationships=JSON.parse(JSON.stringify(relationshipsDf.result))
          this.mappedIds = pointsDF['result'].map(x=>{return {haystack_id:x.haystack_id,connector_id:x.connector_id}})
          let childrenList=[]
          let equipDetails=[]
          for(let equipment of equipsDF.result){
              let points=pointsDF.result.filter(x=>x.equipment_id&&x.equipment_id===equipment.equipment_id).map(x=>{return{
                  id:x.sensor_id,
                  name:x.sensor_name,
                  children: [],
                  equipment_name:equipment.equipment_name,
                  facility_name:facilityName,
                  itemType:"sensor",
                  itemData:x,
              }})
              points.sort((a, b) => (a.name > b.name) ? 1 : -1)
              childrenList[equipment.equipment_name]=points
              equipDetails[equipment.equipment_name]=equipment
          }
          equipsDF.result.sort((a, b) => (a.equipment_name > b.equipment_name) ? 1 : -1)
          let equipPaths=[];
          for (let equip of equipsDF.result){
              let newPath=[]
              if(equip.floor&&equip.floor!==""&&equip.floor!=="NaN"){
                  if (equip.floor.startsWith(".")&&this.$store.state.userStore.user.content.role!=="admin"){
                      continue
                  }
                  newPath=equip.floor.split('>').concat([equip.equipment_name])
              } else if (equip.equipment_type&&equip.equipment_type!==""&&equip.equipment_type!==equip.equipment_name){
                  newPath=[equip.equipment_type,equip.equipment_name]
              } else {
                  newPath=[equip.equipment_name]
              }
              if(newPath.length>1){
                  for (let index=0; index<newPath.length; index++){
                      if(index<newPath.length&&newPath[index]===newPath[index+1]){
                          newPath[index]=newPath[index]+" "
                      }
                  }
              }
              equipPaths.push(newPath)
          }
          equipPaths=sortFloors(equipPaths)
          this.tree=this.arrangeIntoTree(equipPaths,childrenList,equipDetails);
          this.loading=false
      }
    }
  }
</script>

<style scoped>
.cursor-as-pointer{
    cursor: pointer !important;
}
.no-field-underline >>> .v-input__slot::before {
    border-style: none !important;
}
</style>
